<div class="col-auto side-space d-none d-xl-block"></div>
<div class="col-full seatch-panel">
  <mat-form-field class="input-normalize" *accessView="['view_search']">
    <input type="search" matInput placeholder="Search" disabled="disabled" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>
<div class="col-auto d-flex side-space">
  <button mat-icon-button disabled="disabled" class="tools-button" *accessView="['view_notifications']">
    <mat-icon>notifications_none</mat-icon>
  </button>
  <button mat-icon-button class="tools-button" [matTooltip]="'Dark/Light mode'" (click)="onToggle()">
    @if (isDarkTheme()) {
      <mat-icon>light_mode</mat-icon>
    } @else {
      <mat-icon>dark_mode</mat-icon>
    }
  </button>
  @if (snowflakeUrl(); as snowflakeUrl) {
    <button
      mat-icon-button
      class="tools-button"
      (click)="initiateSnowflakeSSO(snowflakeUrl)"
      [matTooltip]="'Snowflake'"
      *accessView="['view_snowflake']"
      data-testId="snowflake_button"
    >
      <mat-icon>snowflake</mat-icon>
    </button>
  }
  @if (thoughtSpotUrl(); as thoughtSpotUrl) {
    <button
      mat-icon-button
      class="tools-button"
      (click)="navigateToProduct(thoughtSpotUrl)"
      [matTooltip]="'ThoughtSpot'"
      *accessView="['view_thoughtspot']"
      data-testId="thoughspot_button"
    >
      <mat-icon>thoughtspot</mat-icon>
    </button>
  }
  <button
    mat-icon-button
    class="tools-button"
    (click)="navigateToDilikoStatusPage()"
    [matTooltip]="'Diliko Status Page'"
    data-testId="diliko_status_page_button"
  >
    <mat-icon svgIcon="status_page"></mat-icon>
  </button>
</div>
